export const ADD_CUSTOMER_SUCCESS = "redux_store:customers.success.post";
export const DELETE_CUSTOMER_SUCCESS = "redux_store:customers.success.delete";
export const BULK_DELETE_CUSTOMER_SUCCESS = "redux_store:customers.success.bulk_delete";
export const UPDATE_CUSTOMER_SUCCESS = "redux_store:customers.success.patch";
export const FUSE_CUSTOMERS_SUCCESS = "redux_store:customers.success.fuse";


// WEBPACK FOOTER //
// ./src/successes/customers.js